import { useServicesContent } from "@/hooks/useServicesContent";
import { Skeleton } from "@/components/ui/skeleton";

export function ServicesHero() {
  const { content, loading } = useServicesContent("hero");
  const heroData = content[0]?.content_value;

  if (loading) {
    return (
      <section className="bg-gradient-to-r from-[#f4fbf7] to-white py-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 space-y-4">
            <Skeleton className="h-12 w-96 mx-auto" />
            <Skeleton className="h-6 w-[600px] mx-auto" />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-gradient-to-r from-[#f4fbf7] to-white py-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-brand-primary mb-6">
            {heroData?.title || "Nossos Serviços"}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {heroData?.subtitle || "Soluções personalizadas para cada necessidade, sempre com foco no seu bem-estar"}
          </p>
        </div>
      </div>
    </section>
  );
}
